export default "__VITE_ASSET__BQIpvxeL__"